export const areaCardData = (record) => {
  const { name, area_name, subtitle, area_subtitle } = record;

  return {
    title: name || area_name,
    subtitles: [subtitle || area_subtitle],
  };
};
